import React, { useRef, MouseEvent } from 'react';
import {
  Link,
  MoreInfoCard,
  MoreInfoCardBody,
  MoreInfoCardGrid,
  MoreInfoCardImage,
  SecondarySection,
  SectionSubTitle,
} from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { createElementKey } from 'utils';
import { analyticsUtils } from 'utils/analytics-utils';
import { FENCES_TYPES_MAP, FencesTypeCardStructure } from './fences-types-section-constants';
import { FencesMainPageType } from '../../fences-types';

type FencesTypesSectionProps = {
  elementBlock: string;
  mainPageType: FencesMainPageType;
};

export const FencesTypesSection: React.FC<FencesTypesSectionProps> = ({ elementBlock, mainPageType }) => {
  const cardRefs = useRef<HTMLAnchorElement[]>([]);
  const typesList = FENCES_TYPES_MAP[mainPageType];

  const promotions = typesList.map(({ title }: FencesTypeCardStructure, index: number) => ({
    name: elementBlock,
    creative: title,
    position: (index + 1).toString(),
  }));

  usePromoViewEvent(cardRefs, elementBlock, promotions);

  /**
   * Обработчик нажатия на карточку с типами заборов
   */
  const handleCardClick = (index: number) => () => {
    analyticsUtils.promoClickEvent(elementBlock, promotions[index]);
  };

  const handleCardWheelClick = (e: MouseEvent, index: number) => {
    if (e.button === 1) {
      handleCardClick(index)();
    }
  };

  return (
    <SecondarySection>
      <SectionSubTitle margin="m">Типы заборов</SectionSubTitle>

      <MoreInfoCardGrid cardNumber={typesList.length} cardPerRow={2}>
        {typesList.map(({ imgSrc, title, link }, index) => (
          <Link
            key={createElementKey('fences-type', index)}
            {...link}
            onClick={handleCardClick(index)}
            onAuxClick={e => handleCardWheelClick(e, index)}
            data-position={index}
            refCb={(el: HTMLAnchorElement | null) => {
              if (el && cardRefs) cardRefs.current[index] = el;
            }}>
            <MoreInfoCard>
              <MoreInfoCardImage src={imgSrc} alt={title} title={title} />
              <MoreInfoCardBody title={title} />
            </MoreInfoCard>
          </Link>
        ))}
      </MoreInfoCardGrid>
    </SecondarySection>
  );
};
